import { DndContext }                  from '@dnd-kit/core';
import { DragEndEvent }                from '@dnd-kit/core';
import DragIcon                        from '@/assets/icons/DragIcon';
import { PointerSensor }               from '@dnd-kit/core';
import React                           from 'react';
import { SortableContext }             from '@dnd-kit/sortable';
import SortableItem                    from './components/SortableItem/SortableItem';
import { arrayMove }                   from '@dnd-kit/sortable';
import { closestCenter }               from '@dnd-kit/core';
import { useSensor }                   from '@dnd-kit/core';
import { useSensors }                  from '@dnd-kit/core';
import { verticalListSortingStrategy } from '@dnd-kit/sortable';

export type SortableListItem = {
	id: number,
	render: () => JSX.Element;
}

interface ISortableListProps {
	items: SortableListItem[];
	onListChange?: (items: SortableListItem[]) => void;
}

const SortableList = (props: ISortableListProps) => {
	const { items, onListChange } = props;
	const [listItems, setListItems] = React.useState(items);

	const sensors = useSensors(
		useSensor(PointerSensor),
	);

	React.useEffect(() => {
		if (onListChange) {
			onListChange(listItems);
		}
	}, [listItems]);

	return (
		<div>
			<DndContext 
				sensors={sensors}
				collisionDetection={closestCenter}
				onDragEnd={handleDragEnd}
			>
				<SortableContext 
					items={listItems}
					strategy={verticalListSortingStrategy}
				>
					{listItems.map((item, index) => {
						return (
							<SortableItem 
								key={item.id} 
								dragIcon={<DragIcon color="#A7A8A7" fontSize="20px" />}
								item={item} 
								index={index} 
								listLength={listItems.length}
							/>
						);
					})}
				</SortableContext>
			</DndContext>
		</div>
	);

	function handleDragEnd(event: DragEndEvent) {
		const {active, over} = event;
		
		if (active.id !== over?.id) {
			
			setListItems((listItems) => {
				const oldIndex = listItems.findIndex(item => item.id === active.id);
				const newIndex = listItems.findIndex(item => item.id === over?.id);

				return arrayMove(listItems, oldIndex, newIndex);
			});
		}
	}
}

export default SortableList;